import { render } from "./PageOptionAttributes.vue?vue&type=template&id=90e86882"
import script from "./PageOptionAttributes.vue?vue&type=script&lang=js"
export * from "./PageOptionAttributes.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__